export default "__VITE_ASSET__7KPLHhW0__"